module.exports = __webpack_public_path__ + "static/media/up-arrow-button-svgrepo-com.f2c9e009.svg";